"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonTether = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRequirements_1 = require("../CardRequirements");
var Card_1 = require("../Card");
var MoonTether = (function (_super) {
    __extends(MoonTether, _super);
    function MoonTether() {
        return _super.call(this, {
            name: CardName_1.CardName.MOON_TETHER,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.SPACE],
            cost: 18,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SPACE, 6); }),
            cardDiscount: { amount: 2 },
            metadata: {
                cardNumber: 'M90',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you play a card, you pay 2 M€ less for it.', function (eb) {
                        eb.empty().startEffect.megacredits(-2);
                    }).br;
                }),
                description: 'Requires 6 Space tags.',
                victoryPoints: 1,
            },
        }) || this;
    }
    ;
    MoonTether.prototype.play = function () {
        return undefined;
    };
    MoonTether.prototype.getCardDiscount = function () {
        return 2;
    };
    MoonTether.prototype.getVictoryPoints = function () {
        return 1;
    };
    return MoonTether;
}(Card_1.Card));
exports.MoonTether = MoonTether;
//# sourceMappingURL=MoonTether.js.map